const checkError = (error) => {
    console.log(error);

    if (typeof error === 'string') {
        return error;
    }
    if (error.response && error.response.data) {
        return error.response.data.message;
    }
    if (Array.isArray(error.errors)) {
        return error.errors.map((err) => err.message).join(', ');
    }
    if (error.message) {
        return error.message;
    }

    return 'Unknown error';
};

export default checkError;
